export enum AvailableTabs {
  LoadInformation = 'loadInformation',
  Orders = 'orders',
  AppointmentScheduling = 'appointmentScheduling',
  TrackAndTrace = 'trackAndTrace',
  Outbox = 'outbox',
}
